module.exports = __webpack_public_path__ + "img/cloundwise1.046fb114.png";